import { useQuery } from '@tanstack/react-query';
import { ApiClient } from 'lib/api/client';
import { useStore } from 'lib/store';
import { QUERY_KEYS } from 'settings/config';
import { useApiReady } from './use-api-ready';

type Params = {
  orgId?: string;
};

export const getOrgConfigQueryKey = (orgId?: string | null) => [
  QUERY_KEYS.orgConfig,
  orgId,
];

/** Get the config (products, homepage reports) for the active buyer org */
export function useOrgConfig({ orgId: overrideOrgId }: Params = {}) {
  const enabled = useApiReady();
  const activeBuyerOrgId = useStore((store) => store.activeBuyerOrgId);
  const orgId = overrideOrgId || activeBuyerOrgId;

  return useQuery(
    getOrgConfigQueryKey(orgId),
    () =>
      new ApiClient().organisationApi.orgConfigRetrieve({
        buyerOrgId: orgId || '',
      }),
    {
      select: (data) => data.data,
      enabled: enabled && !!orgId,
    }
  );
}
